/**
 * Establish communication with the site
 */
export var communicateToSite = function (actionCallback) {
    var onMessage = function (event) {
        if (typeof event.data === 'string' && event.data.charAt(0) === '{') {
            try {
                var data = JSON.parse(event.data);
                if (data.gaMsg === true) {
                    actionCallback.call(null, data);
                }
            }
            catch (e) {
                // AHHHH!
            }
        }
    };
    window.addEventListener('message', onMessage, false);
};
export default communicateToSite;
